export default {
	API_SERVER:"https://api.sltic.se"
};
